import { NgModule } from 'angular-ts-decorators';

import { moduleName } from '../constants';

import { HeroCustomizerV3EngravingComponent } from './hero-customizer-v3-engraving.component';

@NgModule({
  declarations: [
    HeroCustomizerV3EngravingComponent,
  ],
  id: `${moduleName}.engraving`,
  providers: [],
})
export class HeroCustomizerV3EngravingModule {
}
